import { current, isDraft, type Draft } from 'immer';

/**
 * Deep-copies plain document data. Safe to call on immer drafts (which are Proxies and cannot be
 * passed to `structuredClone` directly).
 */
export function cloneData<T>(value: T): T {
  return structuredClone(isDraft(value) ? (current(value as Draft<T>) as T) : value);
}
